// 定义API地址
const opDevAPI = "https://op-api.yt.starmerx.com";
const opProdAPI = "https://analytics.garvee.com";
// const opProdAPI = "https://op.starmerx.com";
const brandAPI = "https://brandservice.test.starmerx.com";
let ENV = "prod"; // 环境变量
const opAPI = ENV === "dev" ? opDevAPI : opProdAPI;
const adminAPI = ENV === "dev" ? "https://garvee-admin.nt.starmerx.com" : "https://admin-api.garvee.com";

// 封装fetch请求函数
async function fetchRequest(method, url, data = null, headers = {}) {
  const options = {
    method: method,
    headers: {
      ...headers,
    },
  };

  if (data) {
    // 判断data是否包含File或文件数组
    const hasFile = Object.values(data).some((value) => {
      if (value instanceof File) return true;
      if (Array.isArray(value) && value.some((item) => item instanceof File))
        return true;
      return false;
    });

    if (hasFile) {
      // 处理文件上传
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          // 如果是数组，逐个append
          value.forEach((item) => formData.append(key, item));
        } else {
          formData.append(key, value);
        }
      });
      options.body = formData;
    } else {
      // 普通数据，使用 JSON
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(data);
    }
  }

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`Network error: ${response.status} ${response.statusText}`);
  }
  return await response.json();
}

// 生成符合UUID v4标准的函数（利用crypto API）
function generateUUID() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // 版本号4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // 变体
  const hexBytes = Array.from(bytes).map((b) =>
    b.toString(16).padStart(2, "0")
  );
  return (
    hexBytes.slice(0, 4).join("") +
    "-" +
    hexBytes.slice(4, 6).join("") +
    "-" +
    hexBytes.slice(6, 8).join("") +
    "-" +
    hexBytes.slice(8, 10).join("") +
    "-" +
    hexBytes.slice(10, 16).join("")
  );
}

// 获取本地存储的匿名ID，若无则生成并保存
function getOrCreateAnonymousId() {
  const STORAGE_KEY = "garvee_anonymous_id";
  let anonymousId = localStorage.getItem(STORAGE_KEY);
  if (!anonymousId) {
    anonymousId = generateUUID();
    localStorage.setItem(STORAGE_KEY, anonymousId);
  }
  return anonymousId;
}

// 使用 navigator.sendBeacon 发送行为日志
function sendBehaviorLog(data = {}) {
  // 确保 data.request_json 中包含用户 ID
  if (data.request_json) {
    data.request_json.user_id = getOrCreateAnonymousId();
  } else {
    data.request_json = {
      user_id: getOrCreateAnonymousId(),
    };
  }
  // 将整个 data 对象转换为 JSON 字符串
  const jsonData = JSON.stringify(data);
  // 创建 Blob 对象，设置 MIME 类型为 application/json
  const blob = new Blob([jsonData], { type: "application/json" });
  // 构造目标 URL
  const url = `${opAPI}/knowledge/garvee_log/save_log/`;
  // 使用 navigator.sendBeacon 发送请求
  const success = navigator.sendBeacon(url, blob);
  // 返回布尔值表示请求是否被成功排队
  return success;
}

// 提交延保表单
function subWarrantyForm(data) {
  return fetchRequest(
    "POST",
    `${opAPI}/complaint/brand_warranty_extension/save_brand_warranty_extension/`,
    data
  );
}

// 提交空调安装表单
function subAcInstallForm(data) {
  return fetchRequest(
    "POST",
    `${opAPI}/complaint/ac_order/create_ac_order/`,
    data
  );
}

// 获取订单物流追踪信息
function getOrderTrackingInfo(params) {
  const queryParams = new URLSearchParams({ ...params, update_oms_events: 'false' }).toString();
  return fetchRequest(
    "POST",
    `${adminAPI}/api/v1/order_tracking/get_order_info/?${queryParams}`,
    null,
    { "x-shop-id": "019d8fc2-2f5e-7417-b9cf-b423c4aef902" }
  );
}
